<template>
  <div class="title">
    <span>{{ title }}</span>
  </div>
  <div class="col  field style-04">
    <div class="row" v-for="(item, index) in localData" :key="index" :class="{add : index != 0}">
      <div class="field-one input-text-1 no-line">
        <input type="text" v-model="item.name" :maxlength="title === '작품 소장 내역'? 50 : 999" :placeholder="placeholder">
      </div>
      <button v-if="index === localData.length - 1" type="button" class="add-list add" @click="addListItem(item.type, item.typeLabel)">
        <img src="@/assets/images/icon/ico_add_c.png" alt="">
      </button>
      <button type="button" class="add-list delete" @click="removeItem(item.type, index)">
        <img src="@/assets/images/icon/ico_minus_c.png" alt="">
      </button>
    </div>
  </div>
</template>

<script setup>
import { reactive, toRefs } from 'vue'

const props = defineProps({
  title: String,
  placeholder: String,
  data: Array,
});
const { title, placeholder, data } = toRefs(props);

// props.data를 reactive 형태로 변환한 내부 데이터
const localData = reactive(
  (props.data && props.data.length > 0) // props.data가 유효한 경우
    ? props.data.map((item) => ({
        id: item.id,
        name: item.name,
    }))
    : [{ id: 0, name: '' }] // props.data가 없거나 빈 배열인 경우 기본값 추가
);

const maxItems = title.value === "인터뷰 링크" ? 3 : 30;
const addListItem = () => {
  if (localData.length >= maxItems) {
    alert(`최대 ${maxItems}개까지 등록 가능합니다`);
    return;
  }
  localData.push({ id: 0, name: ''  });
};
const removeItem = (type, index) => {
  localData.splice(index, 1);

  // 데이터가 비어 있으면 기본값 추가
  if (localData.length === 0) {
    addListItem();
  }
};

const getFilteredData = () => {
  return localData.filter(({ name }) => {
    return typeof name === 'string' && name.trim() !== '';
  });
};


defineExpose({
  getFilteredData
});
</script>

<style scoped></style>